import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Clase from './pages/Clase';
import Bono from './pages/Bono';
import Eventos from './pages/Eventos';
import Evento from './pages/Evento';
import Horarios from './pages/Horarios';
import Reserva from './pages/Reserva';
import MisReservas from './pages/MisReservas';
import MisBonos from './pages/MisBonos';
import BonoCompraSuccess from './pages/BonoCompraSuccess';
import BonoCompraCancelled from './pages/BonoCompraCancelled';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ActivarAdmin from './pages/ActivarAdmin';

import AdminGuard from './components/admin/AdminGuard';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminHorarios from './pages/admin/AdminHorarios';
import AdminProfesores from './pages/admin/AdminProfesores';
import AdminClasesTipos from './pages/admin/AdminClasesTipos';
import AdminBonosTipos from './pages/admin/AdminBonosTipos';
import AdminEventos from './pages/admin/AdminEventos';
import AdminReservas from './pages/admin/AdminReservas';
import AdminMiCuenta from './pages/admin/AdminMiCuenta';
import AdminProfesorDatosFiscales from './pages/admin/AdminProfesorDatosFiscales';
import AdminProfesorDescuentos from './pages/admin/AdminProfesorDescuentos';
import AdminConfigEmailsProfesor from './pages/admin/AdminConfigEmailsProfesor';
import AdminProfesorTarifas from './pages/admin/AdminProfesorTarifas';
import AdminPagosProfesor from './pages/admin/AdminPagosProfesor';
import AdminSesiones from './pages/admin/AdminSesiones';
import AdminConfigEstudio from './pages/admin/AdminConfigEstudio';
import AdminRedes from './pages/admin/AdminRedes';
import AdminBonosComprados from './pages/admin/AdminBonosComprados';
import AdminAlumnosTop from './pages/admin/AdminAlumnosTop';
import AdminAlumnosInactivos from './pages/admin/AdminAlumnosInactivos';
import AdminUsuariosAdmin from './pages/admin/AdminUsuariosAdmin';
import AdminUsuariosAdminInvitaciones from './pages/admin/AdminUsuariosAdminInvitaciones';
import AdminUsuariosAdminAuditLog from './pages/admin/AdminUsuariosAdminAuditLog';

import ProfesorGuard from './components/profesor/ProfesorGuard';
import ProfesorLayout from './components/profesor/ProfesorLayout';
import ProfesorDashboard from './pages/profesor/ProfesorDashboard';
import ProfesorClase from './pages/profesor/ProfesorClase';
import ProfesorReservarComoAlumno from './pages/profesor/ProfesorReservarComoAlumno';

import './App.css';
// mejora-web F4
import Videos from './pages/Videos';
import AdminGaleria from './pages/admin/AdminGaleria';
import AdminVideos from './pages/admin/AdminVideos';
import AdminPromociones from './pages/admin/AdminPromociones';
import AdminCodigos from './pages/admin/AdminCodigos';
import AdminTramosEmpresa from './pages/admin/AdminTramosEmpresa';
import AdminPedidosEmpresa from './pages/admin/AdminPedidosEmpresa';
import Empresas from './pages/Empresas';
import SolicitarClase from './pages/SolicitarClase';
import ClaseParticular from './pages/ClaseParticular';
import AdminSolicitudes from './pages/admin/AdminSolicitudes';
import EmpresaPedido from './pages/EmpresaPedido';
import Regalo from './pages/Regalo';
import AdminTextos from './pages/admin/AdminTextos';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/activar-admin/:token" element={<ActivarAdmin />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/clases/:slug" element={<Clase />} />
            <Route path="/bonos/:slug" element={<Bono />} />
            <Route path="/regalo" element={<Regalo />} />
            <Route path="/empresas" element={<Empresas />} />
            <Route path="/clase-particular" element={<SolicitarClase />} />
            <Route path="/clase-particular/:token" element={<ClaseParticular />} />
            <Route path="/empresas/pedido/:token" element={<EmpresaPedido />} />
            <Route path="/eventos" element={<Eventos />} />
            <Route path="/eventos/:slug" element={<Evento />} />
            <Route path="/horarios" element={<Horarios />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/reserva/:codigo" element={<Reserva />} />
            <Route path="/mis-reservas" element={<MisReservas />} />
            <Route path="/mis-bonos" element={<MisBonos />} />
            <Route path="/bonos/success" element={<BonoCompraSuccess />} />
            <Route path="/bonos/cancelled" element={<BonoCompraCancelled />} />
          </Route>
          <Route element={<AdminGuard><AdminLayout /></AdminGuard>}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/horarios" element={<AdminHorarios />} />
            <Route path="/admin/profesores" element={<AdminProfesores />} />
            <Route path="/admin/clases-tipos" element={<AdminClasesTipos />} />
            <Route path="/admin/bonos-tipos" element={<AdminBonosTipos />} />
            <Route path="/admin/reservas" element={<AdminReservas />} />
            <Route path="/admin/mi-cuenta" element={<AdminMiCuenta />} />
            <Route path="/admin/profesores/:id/datos-fiscales" element={<AdminProfesorDatosFiscales />} />
            <Route path="/admin/profesores/:id/descuentos" element={<AdminProfesorDescuentos />} />
            <Route path="/admin/configuracion-emails" element={<AdminConfigEmailsProfesor />} />
            <Route path="/admin/profesor-tarifas" element={<AdminProfesorTarifas />} />
            <Route path="/admin/pagos-profesor" element={<AdminPagosProfesor />} />
            <Route path="/admin/sesiones" element={<AdminSesiones />} />
            <Route path="/admin/configuracion-estudio" element={<AdminConfigEstudio />} />
            <Route path="/admin/redes" element={<AdminRedes />} />
            <Route path="/admin/bonos-comprados" element={<AdminBonosComprados />} />
            <Route path="/admin/eventos" element={<AdminEventos />} />
            <Route path="/admin/alumnos-top" element={<AdminAlumnosTop />} />
            <Route path="/admin/alumnos-inactivos" element={<AdminAlumnosInactivos />} />
            <Route path="/admin/usuarios-admin" element={<AdminUsuariosAdmin />} />
            <Route path="/admin/usuarios-admin/invitaciones" element={<AdminUsuariosAdminInvitaciones />} />
            <Route path="/admin/usuarios-admin/audit-log" element={<AdminUsuariosAdminAuditLog />} />
            {/* mejora-web F4 */}
            <Route path="/admin/galeria" element={<AdminGaleria />} />
            <Route path="/admin/videos" element={<AdminVideos />} />
            <Route path="/admin/promociones" element={<AdminPromociones />} />
            <Route path="/admin/codigos" element={<AdminCodigos />} />
            <Route path="/admin/tramos-empresa" element={<AdminTramosEmpresa />} />
            <Route path="/admin/pedidos-empresa" element={<AdminPedidosEmpresa />} />
            <Route path="/admin/solicitudes-clase" element={<AdminSolicitudes />} />
            <Route path="/admin/portada" element={<AdminTextos />} />
          </Route>
          <Route element={<ProfesorGuard><ProfesorLayout /></ProfesorGuard>}>
            <Route path="/profesor" element={<ProfesorDashboard />} />
            <Route path="/profesor/clase/:id" element={<ProfesorClase />} />
            <Route path="/profesor/reservar-como-alumno" element={<ProfesorReservarComoAlumno />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
